import { linkBlockFor } from "@/lib/internal-links";

/**
 * Contextual internal-link block rendered on the site's top-crawled pages.
 *
 * Plain <a href> on purpose: these are the crawl paths we want Google to
 * follow, so they must be real, server-rendered anchors with keyword-matched
 * anchor text.
 */
export function InternalLinkBlock({ path }: { path: string }) {
  const block = linkBlockFor(path);
  if (!block) return null;

  return (
    <nav aria-label={block.heading} className="glass rounded-2xl p-6 mt-8">
      <h2 className="text-xl font-bold">{block.heading}</h2>
      <p className="aeo-answer mt-1 text-sm text-muted-foreground">{block.intro}</p>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {block.links.map((l) => (
          <li key={l.href} className="rounded-lg border border-border/60 p-3">
            <a href={l.href} className="text-sm font-semibold text-primary hover:underline">
              {l.label}
            </a>
            <p className="mt-1 text-xs text-muted-foreground">{l.blurb}</p>
          </li>
        ))}
      </ul>
    </nav>
  );
}
